import { render, staticRenderFns } from "./CustomLink.vue?vue&type=template&id=bec8af68"
import script from "./CustomLink.vue?vue&type=script&lang=js"
export * from "./CustomLink.vue?vue&type=script&lang=js"
import style0 from "./CustomLink.vue?vue&type=style&index=0&id=bec8af68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports